var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9 9" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M9 4.5a.91.91 0 0 1-.91.91H5.41v2.68a.91.91 0 0 1-1.82 0V5.41H.91a.91.91 0 0 1 0-1.82h2.68V.91a.91.91 0 0 1 1.82 0v2.68h2.68A.91.91 0 0 1 9 4.5z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Plus.svg